import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function getAllStatistics(token,data) {
    return axios.post(`${CURRENT_API_URL}/swinternalsystem/getAllStatistics`, data,{
    headers: {
        'Authorization': token,
    }
    }).then(res => {
        // notify.NotifySuccess("All statistics successfully fetched. Thank You!");       
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while fetching statistics. please try again later.");
        return false;
    });
}

export default getAllStatistics;